import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { useAuthStore } from "@/stores/authStore";
import { AdminSidebar } from "@/features/admin/components/AdminSidebar";
import { Button } from "@/components/ui/button";

export function AdminLayout() {
  const { t } = useTranslation();
  const profile = useAuthStore((state) => state.profile);
  const logOut = useAuthStore((state) => state.logOut);
  const displayName = [profile?.first_name, profile?.last_name].filter(Boolean).join(" ").trim()
    || t("adminWorkspace.layout.fallbackName");

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,rgba(126,102,68,0.18),transparent_38%),linear-gradient(180deg,#120f0c,#1b1511_52%,#0f0d0a)] px-4 py-5 text-[#f7efe4] sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-[1600px] gap-5 xl:grid-cols-[280px_minmax(0,1fr)]">
        <AdminSidebar />

        <section className="rounded-[2rem] border border-white/8 bg-[linear-gradient(180deg,rgba(36,29,23,0.96),rgba(18,15,12,0.96))] p-5 shadow-[0_32px_90px_-42px_rgba(0,0,0,0.85)]">
          <header className="mb-5 flex flex-col gap-4 rounded-[1.65rem] border border-white/8 bg-white/[0.035] px-5 py-5 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <div className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#d2b793]">
                <ShieldCheck className="size-4" />
                {t("adminWorkspace.layout.eyebrow")}
              </div>
              <h1 className="mt-3 font-display text-4xl leading-none text-[#fff7ef]">
                {t("adminWorkspace.layout.title")}
              </h1>
              <p className="mt-3 max-w-3xl text-sm leading-7 text-[#dbcdbd]/76">
                {t("adminWorkspace.layout.subtitle")}
              </p>
            </div>

            <div className="flex items-center gap-3">
              <div className="rounded-full border border-white/10 bg-black/20 px-4 py-2 text-sm text-[#efe1cf]">
                {displayName}
              </div>
              <Button type="button" variant="outline" onClick={() => void logOut()}>
                {t("shell.account.logout")}
              </Button>
            </div>
          </header>

          <Outlet />
        </section>
      </div>
    </div>
  );
}
